/** Public marketplace only supports card ('1') and list ('2') views. */
export function getPublicMarketplaceView(storedView) {
  return storedView === '2' ? '2' : '1'
}
